import $ from 'jquery'

$(function () {
  return $('.secondary-nav.js-nav-expand a').on('click', function (e) {
    let li, target;
    target = $(e.target);
    li = $(e.target.parentElement);
    if (li.hasClass('is-selected')) {
      e.preventDefault();
      target.closest('.secondary-nav').toggleClass('open');
    }
  });
});
